import { t } from '@/core/localization';
import { format as formatDate } from 'date-fns';
/**
 * Gets requisites string like "**Invoice1234 dated 01.02.2025**" by name and date, using specified format.
 *
 * Formats:
 *
 * `short` - `dd.MM.yy`
 *
 * `extended` - `dd MMMM yyyy г. в HH:mm`
 *
 * `P` - `04/29/1453`, or any other date-fns formatDate function patter.
 */
export function getSimpleRequisites(title, dated, dateFormat) {
    if (!title)
        return '';
    if (!dated)
        return title;
    const format = dateFormat === 'extended' ? 'dd MMMM yyyy г. в HH:mm' : dateFormat === 'short' ? 'dd.MM.yy' : (dateFormat ?? 'P');
    return `${title} ${t('dated.label')} ${formatDate(dated, format)}`;
}
